import React, { PureComponent } from 'react';

import { Button } from '@mui/material';

import { TiLocationArrowOutline, TiLocationArrow } from 'react-icons/ti';

interface RobotRotateButtonProps {
  toggled: boolean;
  onClick: () => void;
  marginTop: number;
}

export default class RobotRotateButton extends PureComponent<RobotRotateButtonProps> {
  render() {
    return (
      <Button
        variant="contained"
        // `inherit` keeps the icon at the inherited (dark) text color. MUI's
        // implicit default is `primary`, which paints contained buttons with
        // primary.contrastText (white) — invisible on the white background below.
        color="inherit"
        style={{
          backgroundColor: 'white',
          height: 40,
          width: 30,
          // Button's root sets `min-width: 64px`, which would otherwise override
          // the 30px width and stretch this into a wide slab over the map.
          minWidth: 30,
          position: 'absolute',
          left: 10,
          marginTop: this.props.marginTop,
          zIndex: 1,
          padding: 0,
        }}
        onClick={this.props.onClick}
      >
        {this.props.toggled ? (
          <TiLocationArrow size={32} className={'tracking-lock'} />
        ) : (
          <TiLocationArrowOutline size={30} className={'tracking-default'} />
        )}
      </Button>
    );
  }
}
